module.exports = __webpack_public_path__ + "img/icon-minsize.7046acbb.svg";